// extracted by mini-css-extract-plugin
export var block = "local-tasks-module--block--umZWW";
export var zzz = "local-tasks-module--zzz--2VY3f";